/**
 * Dialog: mover batch a otra nómina o fecha custom.
 * Extraído de CxPPanel.jsx en Iter 236.m.14 (Carlos).
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { DatePickerInput } from '../../ui/date-picker';

export function BatchMoverDialog({
  open,
  busy,
  count,
  nominas,
  fechaCustom,
  setFechaCustom,
  onClose,
  onMover,
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-md" data-testid="dialog-batch-mover">
        <DialogHeader>
          <DialogTitle>Mover {count} factura{count === 1 ? '' : 's'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <p className="text-xs text-muted-foreground">
            Movés todas las seleccionadas a la misma nómina/fecha. El refresh se hace una vez al final.
          </p>
          <div>
            <Label className="text-xs">Próximos viernes</Label>
            <div className="grid grid-cols-2 gap-1.5 mt-1">
              {(nominas || []).slice(0, 6).map((nDest) => (
                <Button
                  key={nDest.id}
                  variant="outline"
                  size="sm"
                  className="h-8 text-[11px] justify-start"
                  disabled={busy}
                  onClick={() => onMover(nDest.id, null)}
                  data-testid={`btn-batch-dest-${nDest.id}`}
                >
                  {nDest.nombre}
                </Button>
              ))}
            </div>
          </div>
          <div className="text-center text-xs text-muted-foreground">o fecha custom</div>
          <div className="flex gap-2">
            <div className="flex-1">
              <DatePickerInput
                value={fechaCustom}
                onChange={setFechaCustom}
                data-testid="datepicker-batch-mover"
              />
            </div>
            <Button
              size="sm"
              disabled={!fechaCustom || busy}
              onClick={() => onMover(null, fechaCustom)}
            >
              Crear y mover
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
